import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../field.interface";
import { InputComponent } from "../input/input.component";
import { PhoneNoComponent } from "../phone-no/phone-no.component";
import { SelectComponent } from "../select/select.component";


type InputType = 'text' | 'select' | 'countrycode';
const componentMapper: Record<InputType, any> =  {
  text: InputComponent,
//   button: ButtonComponent,
  select: SelectComponent,
//   date: DateComponent,
//   radiobutton: RadiobuttonComponent,
//   checkbox: CheckboxComponent,
//   price:PriceComponent,
//   file:FileUploadComponent,
//   password:PasswordComponent,
//   passwordConfirm:PasswordConfirmComponent,
//   image:ImageComponent,
  countrycode:PhoneNoComponent
};
@Directive({
    selector: "[dynamicField]",
    standalone: true
})
export class DynamicFieldDirective implements OnInit, OnDestroy {
  @Input() field: FieldConfig |any;
  @Input() group: UntypedFormGroup |any;
  @Input() index: any;
  @Input() indexInital: any;
  componentRef: any;

  @Output() valueChange = new EventEmitter();
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.inputType as InputType]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    this.componentRef.instance.index = this.index;
    this.componentRef.instance.indexInital = this.indexInital;

    if (this.componentRef.instance.valueChange) {
      this.componentRef.instance.valueChange.subscribe((value: any) => {

        console.log(value);

        this.componentRef.instance.indexInital = value;
        
        this.valueChange.emit(value);
      });
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy(); // Clean up component on directive destroy
    }
  }
}
